var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "map-location-panel" },
    [
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.mapReady,
            expression: "mapReady",
          },
        ],
        ref: "mapBox",
        staticClass: "map-box",
      }),
      !_vm.mapReady
        ? _c(
            "div",
            { staticClass: "map-box map-placeholder" },
            [
              _vm.mapLoading
                ? _c("a-spin")
                : !_vm.configured
                ? _c("a-empty", {
                    attrs: {
                      description:
                        "未配置腾讯地图Key，请到 系统管理→系统配置→地址定位与地图服务 维护后使用",
                    },
                  })
                : _vm.loadFailed
                ? _c(
                    "div",
                    { staticClass: "map-fail" },
                    [
                      _c(
                        "a-empty",
                        [
                          _c("template", { slot: "description" }, [
                            _c("div", { staticClass: "map-fail-text" }, [
                              _vm._v(
                                "地图加载失败：请到腾讯位置服务控制台(lbs.qq.com)检查该 Key 已启用「Web端(JS API)」产品，且域名白名单包含 erp.mgskerp.cn"
                              ),
                            ]),
                          ]),
                        ],
                        2
                      ),
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.retryLoad },
                        },
                        [_vm._v("重试")]
                      ),
                    ],
                    1
                  )
                : _c("a-empty", {
                    attrs: { description: "地图加载中，请稍候" },
                  }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "a-row",
        { staticClass: "panel-row" },
        [
          _c("span", { staticClass: "coord-label" }, [_vm._v("纬度")]),
          _c("a-input-number", {
            staticStyle: { width: "160px" },
            attrs: { min: -90, max: 90, precision: 6, disabled: _vm.disabled },
            on: { change: _vm.onManualLatLng },
            model: {
              value: _vm.localLat,
              callback: function ($$v) {
                _vm.localLat = $$v
              },
              expression: "localLat",
            },
          }),
          _c("span", { staticClass: "coord-label coord-gap" }, [
            _vm._v("经度"),
          ]),
          _c("a-input-number", {
            staticStyle: { width: "160px" },
            attrs: {
              min: -180,
              max: 180,
              precision: 6,
              disabled: _vm.disabled,
            },
            on: { change: _vm.onManualLatLng },
            model: {
              value: _vm.localLng,
              callback: function ($$v) {
                _vm.localLng = $$v
              },
              expression: "localLng",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }